export default __webpack_public_path__ + "static/media/next-slide.c6e0b070.svg";